export const subscriptionhistoryConstants = {
    GETALL_REQUEST: 'SUBSCRIPTIONHISTORY_GETALL_REQUEST',
    GETALL_SUCCESS: 'SUBSCRIPTIONHISTORY_GETALL_SUCCESS',
    GETALL_FAILURE: 'SUBSCRIPTIONHISTORY_GETALL_FAILURE',

    DELETE_REQUEST: 'SUBSCRIPTIONHISTORY_DELETE_REQUEST',
    DELETE_SUCCESS: 'SUBSCRIPTIONHISTORY_DELETE_SUCCESS',
    DELETE_FAILURE: 'SUBSCRIPTIONHISTORY_DELETE_FAILURE'
};
